// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SgYk","content":"styles_content__skVKl","tableWrap":"styles_tableWrap__1qpp1"};